"use strict";

const Province = require('./Province');

const districtsData = require('./data/districts');

class District {
  constructor(codigo) {
    this._codigo = codigo;
  }

  get codigo() {
    return this._codigo;
  }

  /**
   * Obtener el nombre del distrito
   * @return {String}
   */
  getName() {
    const hasOwnDistrict = (
      districtsData.hasOwnProperty(this._codigo)
    );

    if (hasOwnDistrict === true) {
      return districtsData[this._codigo];
    } else {
      throw new Error(`El código del distrito no existe: ${this._codigo}`);
    }
  }

  /**
   * Obtener la provincia a la que pertenece el distrito
   * @return {Region}
   */
  getProvince() {
    const provinceCode = this._codigo.substr(0, 4);

    return new Province(provinceCode);
  }
}

module.exports = District;
